import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const trimmedEmail = email.trim().toLowerCase();

      await addDoc(collection(db, 'subscribers'), {
        email: trimmedEmail,
        timestamp: new Date()
      });

      setSubscribed(true);
    } catch (err) {
      if (err.code === 'already-exists') {
        setError('This email address is already subscribed.');
      } else {
        setError('Unable to subscribe at this time. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscribe-box">
      <h3>Stay Updated</h3>
      <p>Get notifications about new content and updates</p>
      {!subscribed ? (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            disabled={loading}
            aria-label="Email address"
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
          {error && <div className="error-message" role="alert">{error}</div>}
        </form>
      ) : (
        <div className="success-message" role="status">
          Thanks for subscribing! You'll receive updates soon.
        </div>
      )}
    </div>
  );
};

export default SubscribeForm;
